<template>
  <div>
    <Modal v-model="showModal" :title="title" width="1000">
      <Alert v-if="error" type="warning" show-icon>获取数据失败</Alert>
      <div v-else class="jenkins-job-console-output-content" ref="xwBody">
        <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ content }}</pre>
        <p v-if="timer">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        </p>
      </div>
      <div slot="footer">
        <Button @click="showModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getJenkinsBuildConsole } from '@/api/tools/jenkins'

export default {
  name: 'console-output',
  data () {
    return {
      title: '控制台输出',
      showModal: false,
      error: false,
      content: '',
      timer: null
    }
  },
  methods: {
    getOutput (jenkinsId, jobName, buildNumber) {
      this.error = false
      this.title = '[' + jobName + '][#' + buildNumber + ']控制台输出'
      this.showModal = true
      this.getData(jenkinsId, jobName, buildNumber, false)
    },
    getData (jenkinsId, jobName, buildNumber, bottom = true) {
      getJenkinsBuildConsole(jenkinsId, jobName, buildNumber).then(res => {
        this.content = res.data.output ? res.data.output : res.data
        if (bottom) {
          this.scrollToBottom()
        }
        if (!this.content && !this.timer) {
          this.setTimer(jenkinsId, jobName, buildNumber)
        } else if (this.content && this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }).catch(res => {
        this.error = true
        console.error(res.response)
      })
    },
    // 自动刷新
    setTimer (jenkinsId, jobName, buildNumber) {
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        this.getData(jenkinsId, jobName, buildNumber)
      }, 2000)
    },
    // 滚动条到最底部
    scrollToBottom () {
      setTimeout(() => {
        if (this.$refs.xwBody) {
          // 滚动条长度
          let currentDistance = this.$refs.xwBody.scrollHeight - this.$refs.xwBody.clientHeight
          // 当前滚动条距离顶部的距离
          let currentScrollY = this.$refs.xwBody.scrollTop
          if (currentDistance > 0 && currentDistance > currentScrollY) {
            currentScrollY = Math.ceil((currentDistance - currentScrollY) / 10) + currentScrollY
            currentScrollY = currentScrollY > currentDistance ? currentDistance : currentScrollY
            // 微信和qq浏览器不支持 scrollTo？
            // this.$refs.xwBody.scrollTo(0,currentScrollY);
            this.$refs.xwBody.scrollTop = currentScrollY
            this.scrollToBottom()
          }
        }
      }, 13)
    }
  }
}
</script>

<style scoped>
  .jenkins-job-console-output-content {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
    padding-right: 5px;
  }
  .jenkins-job-console-output-content::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .jenkins-job-console-output-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .jenkins-job-console-output-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
